import { render } from "./SettingsPage.vue?vue&type=template&id=44e04376&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"

import "./SettingsPage.vue?vue&type=style&index=0&id=44e04376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e04376"]])

export default __exports__